// Shared chart color utilities

const DEFAULT_CHART_COLORS = [
  'hsl(var(--Secondary-light-blue-4))', // Light purple
  'hsl(var(--base-chart-3))', // Light blue
  'hsl(var(--Secondary-light-blue-2))', // Very light
  'hsl(var(--Secondary-light-blue-1))', // Light blue alt
  'hsl(var(--base-chart-1))', // Primary chart color
  'hsl(var(--Secondary-light-blue-4))', // Light purple (repeat)
  'hsl(var(--base-chart-3))', // Light blue (repeat)
  'hsl(var(--Secondary-light-blue-2))', // Very light (repeat)
  'hsl(var(--Secondary-light-blue-1))', // Light blue alt (repeat)
  'hsl(var(--base-chart-1))', // Primary (repeat for more options)
  'hsl(var(--Secondary-light-blue-4))',
  'hsl(var(--base-chart-3))',
  'hsl(var(--Secondary-light-blue-2))',
  'hsl(var(--Secondary-light-blue-1))',
  'hsl(var(--base-chart-1))', // Continue cycling
]

// Active state color for highlighting chart elements
export const CHART_ACTIVE_COLOR = '#3455F7'

export function getChartColors(count?: number): string[] {
  if (!count) return DEFAULT_CHART_COLORS

  // If we need more colors than available, cycle through them
  const colors: string[] = []
  for (let i = 0; i < count; i++) {
    colors.push(DEFAULT_CHART_COLORS[i % DEFAULT_CHART_COLORS.length])
  }

  return colors
}
